export class AlarmType {
    uuid: string;
    code: string;
    name: string;
}
